import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
  getMyUserGroupComboVehicleInfoNotePage,
  getComboVehicleInfoNotePage,
  getMyAllCanSee
} from '@/api/businessnoteserv'

export default {
  state: {
    state_BusinessNote_AddObjResult: null,
    state_BusinessNote_GetAllResult: null,
    state_BusinessNote_GetPageResult: null,
    state_BusinessNote_GetDetailResult: null,
    state_BusinessNote_ModifyObjResult: null,
    state_BusinessNote_DeleteObjResult: null,
    state_BusinessNote_GetMyAllResult: null,
    state_BusinessNote_GetMyPageResult: null,
    state_BusinessNote_GetMyUserGroupComboVehicleInfoNotePageResult: null,
    state_BusinessNote_GetComboVehicleInfoNotePageResult: null,
    state_BusinessNote_GetMyAllCanSeeResult: null
  },
  mutations: {
    SET_BUSINESSNOTE_ADDOBJ_RESULT: (state, rst) => {
      state.state_BusinessNote_AddObjResult = rst
    },
    SET_BUSINESSNOTE_GETALL_RESULT: (state, rst) => {
      state.state_BusinessNote_GetAllResult = rst
    },
    SET_BUSINESSNOTE_GETPAGE_RESULT: (state, rst) => {
      state.state_BusinessNote_GetPageResult = rst
    },
    SET_BUSINESSNOTE_GETDETAIL_RESULT: (state, rst) => {
      state.state_BusinessNote_GetDetailResult = rst
    },
    SET_BUSINESSNOTE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_BusinessNote_ModifyObjResult = rst
    },
    SET_BUSINESSNOTE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_BusinessNote_DeleteObjResult = rst
    },
    SET_BUSINESSNOTE_GETMYALL_RESULT: (state, rst) => {
      state.state_BusinessNote_GetMyAllResult = rst
    },
    SET_BUSINESSNOTE_GETMYPAGE_RESULT: (state, rst) => {
      state.state_BusinessNote_GetMyPageResult = rst
    },
    SET_BUSINESSNOTE_GETMYUSERGROUPCOMBOVEHICLEINFONOTEPAGE_RESULT: (state, rst) => {
      state.state_BusinessNote_GetMyUserGroupComboVehicleInfoNotePageResult = rst
    },
    SET_BUSINESSNOTE_GETCOMBOVEHICLEINFONOTEPAGE_RESULT: (state, rst) => {
      state.state_BusinessNote_GetComboVehicleInfoNotePageResult = rst
    },
    SET_BUSINESSNOTE_GETMYALLCANSEE_RESULT: (state, rst) => {
      state.state_BusinessNote_GetMyAllCanSeeResult = rst
    }
  },
  actions: {
    BusinessNoteServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetMyAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETMYALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETMYALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetMyUserGroupComboVehicleInfoNotePage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupComboVehicleInfoNotePage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETMYUSERGROUPCOMBOVEHICLEINFONOTEPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETMYUSERGROUPCOMBOVEHICLEINFONOTEPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetComboVehicleInfoNotePage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getComboVehicleInfoNotePage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETCOMBOVEHICLEINFONOTEPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETCOMBOVEHICLEINFONOTEPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    BusinessNoteServ_GetMyAllCanSee ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAllCanSee(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_BUSINESSNOTE_GETMYALLCANSEE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_BUSINESSNOTE_GETMYALLCANSEE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_BusinessNote_AddObjResult: state => {
      return state.state_BusinessNote_AddObjResult
    },
    get_BusinessNote_GetAllResult: state => {
      return state.state_BusinessNote_GetAllResult
    },
    get_BusinessNote_GetPageResult: state => {
      return state.state_BusinessNote_GetPageResult
    },
    get_BusinessNote_GetDetailResult: state => {
      return state.state_BusinessNote_GetDetailResult
    },
    get_BusinessNote_ModifyObjResult: state => {
      return state.state_BusinessNote_ModifyObjResult
    },
    get_BusinessNote_DeleteObjResult: state => {
      return state.state_BusinessNote_DeleteObjResult
    },
    get_BusinessNote_GetMyAllResult: state => {
      return state.state_BusinessNote_GetMyAllResult
    },
    get_BusinessNote_GetMyPageResult: state => {
      return state.state_BusinessNote_GetMyPageResult
    },
    get_BusinessNote_GetMyUserGroupComboVehicleInfoNotePageResult: state => {
      return state.state_BusinessNote_GetMyUserGroupComboVehicleInfoNotePageResult
    },
    get_BusinessNote_GetComboVehicleInfoNotePageResult: state => {
      return state.state_BusinessNote_GetComboVehicleInfoNotePageResult
    },
    get_BusinessNote_GetMyAllCanSeeResult: state => {
      return state.state_BusinessNote_GetMyAllCanSeeResult
    }
  }
}
